export default "__VITE_ASSET__Dr2CZDkg__"